import React from "react";

const images = [
  {
    src: "https://images.pexels.com/photos/29755707/pexels-photo-29755707.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Sleek black sports car",
    span: "md:col-span-2 md:row-span-2",
  },
  {
    src: "https://images.unsplash.com/photo-1654522660328-eede2194e699?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwyfHxjYXIlMjBjZXJhbWljJTIwY29hdGluZyUyMHNoaW5lfGVufDB8fHx8MTc3NzY1OTAyNHww&ixlib=rb-4.1.0&q=85",
    alt: "Ceramic coated Mercedes",
  },
  {
    src: "https://images.unsplash.com/photo-1647844850804-7199e36a78c0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwxfHxjYXIlMjBjZXJhbWljJTIwY29hdGluZyUyMHNoaW5lfGVufDB8fHx8MTc3NzY1OTAyNHww&ixlib=rb-4.1.0&q=85",
    alt: "Red car in detailing garage",
  },
  {
    src: "https://images.unsplash.com/photo-1754973277204-9b530bb01ef0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBjYXIlMjBkZXRhaWxpbmclMjBkYXJrfGVufDB8fHx8MTc3NzY1OTAyNHww&ixlib=rb-4.1.0&q=85",
    alt: "Red sports car detailing",
    span: "md:col-span-2",
  },
  {
    src: "https://images.unsplash.com/photo-1771491237209-b89bc7290588?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwyfHxjYXIlMjBpbnRlcmlvciUyMGNsZWFuaW5nJTIwZGV0YWlsaW5nfGVufDB8fHx8MTc3NzY1OTAyNHww&ixlib=rb-4.1.0&q=85",
    alt: "Interior deep clean",
  },
];

export default function Gallery() {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="relative py-24 md:py-32 bg-[#050505]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <span className="w-12 h-px bg-red-500" />
              <span className="text-xs tracking-[0.3em] uppercase text-red-500 font-bold">
                Recent Work
              </span>
            </div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl uppercase tracking-tighter">
              Results that <br />
              <span className="text-red-500 italic font-serif tracking-normal lowercase">
                speak
              </span>{" "}
              for themselves.
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 auto-rows-[200px] md:auto-rows-[240px]">
          {images.map((img, i) => (
            <div
              key={i}
              data-testid={`gallery-item-${i}`}
              className={`relative overflow-hidden group border border-zinc-900 ${img.span || ""}`}
            >
              <img
                src={img.src}
                alt={img.alt}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
              <div className="absolute bottom-4 left-4 right-4 translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500">
                <span className="text-xs tracking-[0.25em] uppercase text-red-500 font-bold">
                  Case · 0{i + 1}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
